export enum EThemeType {
    SIEMENS = 'siemens',
    HEALTHINEERS = 'healthineers',
    ENERGY = 'energy'
}
